import http from '@/axios/http'
import { getuser_id, getclient_user_id, getgroup,getuser_iscustomer,getuser_ctid } from "@/localStorage/localStorage";

export function changePassword(newpassword,oldpassword,userId) {
    const data =
        userId?{
        userId:userId,
        newpassword: newpassword
        }:
        {
        oldpassword: oldpassword,
        newpassword: newpassword
        }
    return http({
        url: '/api/user/changePassword',
        method: 'post',
        data
    })
}
//个人资料
export function getUserDetails() {
    return http({
        url: '/api/user/getUserDetails',
        method: 'get'
    })
}
//修改个人资料
export function updateUser({
    user_id,
    nickname,
    roleid,
    userLoginTime,
    user_ctid,
    user_icon,
    user_iscustomer,
    realname,
    user_qq,
    user_sex,
    user_status,
    user_tel,
    username,
    user_addr
}) {
    const data = {
        user_id: user_id,
        nickname: nickname,
        roleid: roleid,
        userLoginTime: userLoginTime,
        user_ctid: user_ctid,
        user_icon: user_icon,
        user_iscustomer: user_iscustomer,
        user_qq: user_qq,
        user_sex: user_sex,
        user_status: user_status,
        user_tel: user_tel,
        username: username,
        user_addr: user_addr,
        realname: realname
    }
    return http({
        url: '/api/user/updateUser',
        method: 'post',
        data
    })
}

//注销登陆
export function userLogout () {
  return http({
    url:'/api/userLogout',
    method:'post'
  })
}

//绑定邮箱
export function bindEmail(email,passwd) {
    return http({
        url:'/api/user/bindEmail',
        method:'post',
        data:{email,passwd}
    })
}